export default __webpack_public_path__ + "static/media/HOW-TO@1x.811ddc76.png";